export var scrollTop = function scrollTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};